import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../_services/dialog.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ScheduledEventService } from '../_services/scheduled-event.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-scheduled-events',
  templateUrl: './scheduled-events.component.html',
  styleUrls: ['../_shared/base.management.component.css']
})

export class ScheduledEventComponent implements OnInit {
  public loading = false;
  public events: Event[] = [];

  constructor(
    private router: Router,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private eventService: ScheduledEventService,
    private spinner: NgxSpinnerService) {

  }

  ngOnInit() {
    this.loadScheduledEvents().subscribe();
  }


  private loadScheduledEvents(): Observable<any> {
   this.loading = true;
   this.spinner.show();
    return this.eventService.getEvents().pipe(
      tap(
        data => {
          this.events = data;
          this.loading = false;
          this.spinner.hide();
        },
        () => {
          this.dialogService.alert('Error', 'Unable to load events', this.viewRef);
          this.loading = false;
          this.spinner.hide();
        }
      )
    );
  }

  public cancelEvent(timerName: string) {

    this.dialogService.confirm('Confirm event cancellation',
    'Are you sure you want to cancel this event?',
    this.viewRef).then(result => {
      if (result) {
        this.loading = true;
        this.spinner.show();
        this.eventService.cancelEvent(timerName)
          .subscribe(
            () => {
              this.loadScheduledEvents().subscribe();
              this.loading = false;
              this.spinner.hide();
            },
            error => {
              this.dialogService.alert(
                'Oh no!',
                'Unable to cancel this event! Please contact support@connectwithcue.com if you continue to see this message',
                this.viewRef);
              this.loading = false;
              this.spinner.hide();
            });
      }
    });

  }


}
